import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";

const contractAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'contractAPI',
    endpoints: (builder) => ({
        // Define endpoints here
        getAllContractType: builder.query({
            query: (pbIncludeBlank) => ({
                url: `/Contract/GetAllContractType?pbIncludeBlank=${pbIncludeBlank}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractById: builder.query({
            query: (plContractKey) => ({
                url: `/Contract/GetContractById?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        addUpdateContractType: builder.mutation({
            query: (data) => ({
                url: `/Contract/AddUpdateContractType`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteContractTypes: builder.mutation({
            query: (lContractTypeKey) => ({
                url: `/Contract/DeleteContractTypes?lContractTypeKey=${lContractTypeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContract: builder.mutation({
            query: (data) => ({
                url: `/Contract/UpdateContract`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractInstallmentTypes: builder.query({
            query: (pbIncludeNone) => ({
                url: `/Contract/GetAllContractInstallmentTypes?pbIncludeNone=${pbIncludeNone}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportContractsList: builder.mutation({
            query: (pbIncludeInactive) => ({
                url: `/Contract/ExportContractsList?pbIncludeInactive=${pbIncludeInactive}`,
                method: 'POST',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addContract: builder.mutation({
            query: (data) => ({
                url: `/Contract/AddContract`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllSalesreps: builder.mutation({
            query: (data) => ({
                url: `/Contract/GetAllSalesreps`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllsalesTax: builder.mutation({
            query: (data) => ({
                url: `/Contract/GetAllsalesTax`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractServicePlanTerms: builder.query({
            query: (pbIncludeBlank) => ({
                url: `/Contract/GetAllContractServicePlanTerms?pbIncludeBlank=${pbIncludeBlank}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),



        getAllContractCoverageCounts: builder.query({
            query: (plContractKey) => ({
                url: `/Contract/GetAllContractCoverageCounts?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getInstrumentTypesForContract: builder.query({
            query: (plContractKey, psInstrumentTypeToInclude) => ({
                url: `/Contract/GetInstrumentTypesForContract?plContractKey=${plContractKey}&psInstrumentTypeToInclude=${psInstrumentTypeToInclude}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteContractCoverageCount: builder.mutation({
            query: (plContractCoverageCountKey) => ({
                url: `/Contract/DeleteContractCoverageCount?plContractCoverageCountKey=${plContractCoverageCountKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteContractDeferralPeriod: builder.mutation({
            query: ({ plContractKey, pdtStartDate }) => ({
                url: `/Contract/DeleteContractDeferralPeriod?plContractKey=${plContractKey}&pdtStartDate=${pdtStartDate}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addUpdateContractCoverageCount: builder.mutation({
            query: (data) => ({
                url: `/Contract/AddUpdateContractCoverageCount`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractsList: builder.mutation({
            query: (data) => ({
                url: `/Contract/GetAllContractsList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractName: builder.mutation({
            query: (data) => ({
                url: `/Contract/UpdateContractName`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addCommissionRate: builder.mutation({
            query: (data) => ({
                url: `/Contract/AddCommissionRate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCommissionRate: builder.mutation({
            query: (data) => ({
                url: `/Contract/GetAllCommissionRate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCommissionRate: builder.mutation({
            query: (data) => ({
                url: `/Contract/DeleteCommissionRate`,
                method: 'DELETE',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCommissionRate: builder.mutation({
            query: (data) => ({
                url: `/Contract/UpdateCommissionRate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractDepartmentsAvailable: builder.query({
            query: (plContractKey) => ({
                url: `/Contract/GetContractDepartmentsAvailable?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractDepartments: builder.query({
            query: ({ plContractDepartmentKey, plContractKey, plClientKey }) => ({
                url: `/Contract/GetContractDepartments?plContractDepartmentKey=${plContractDepartmentKey}&plContractKey=${plContractKey}&plClientKey=${plClientKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addContractDepartments: builder.mutation({
            query: (data) => ({
                url: `Contract/AddContractDepartments`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        contractDepartmentUpdateCostFromScopes: builder.mutation({
            query: (data) => ({
                url: `Contract/ContractDepartmentUpdateCostFromScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        editContractDepartments: builder.mutation({
            query: (data) => ({
                url: `Contract/EditContractDepartments`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractDeferralPeriods: builder.query({
            query: (plContractKey) => ({
                url: `Contract/GetAllContractDeferralPeriods?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addContractDeferralPeriod: builder.mutation({
            query: (data) => ({
                url: `Contract/AddContractDeferralPeriod`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractDeferralPeriod: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractDeferralPeriod`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAmendmentsList: builder.query({
            query: (plContractKey) => ({
                url: `Contract/GetContractAmendmentsList?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteContractAmendments: builder.mutation({
            query: (plContractAmendmentKey) => ({
                url: `/Contract/DeleteContractAmendments?plContractAmendmentKey=${plContractAmendmentKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addContractAmendmentType: builder.mutation({
            query: (data) => ({
                url: `Contract/AddContractAmendmentType`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractAmendmentStatus: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractAmendmentStatus`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        updateSharedRiskDate: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateSharedRiskDate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractRepairsList: builder.query({
            query: (plContractKey) => ({
                url: `Contract/GetContractRepairsList?plContractKey=${plContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractConsumptionDetail: builder.mutation({
            query: (data) => ({
                url: `Contract/GetContractConsumptionDetail`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractExpenseDetails: builder.mutation({
            query: (data) => ({
                url: `Contract/GetContractExpenseDetails`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportContractRepairsList: builder.mutation({
            query: (plContractKey) => ({
                url: `/Contract/ExportContractRepairsList?plContractKey=${plContractKey}`,
                method: 'POST',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        contractScopesAvailable: builder.mutation({
            query: (data) => ({
                url: `/Contract/contractScopesAvailable`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractScopes: builder.mutation({
            query: (data) => ({
                url: `/Contract/GetAllContractScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateContractScope: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractScope`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteContractScope: builder.mutation({
            query: (plContractScopeKey) => ({
                url: `/Contract/DeleteContractScope?plContractScopeKey=${plContractScopeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteContractAmendmentScope: builder.mutation({
            query: (plContractAmendmentScopeKey) => ({
                url: `/Contract/DeleteContractAmendmentScope?plContractAmendmentScopeKey=${plContractAmendmentScopeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getContractRenewalScopes: builder.mutation({
            query: (plContractKey) => ({
                url: `/Contract/GetContractRenewalScopes`,
                method: 'POST',
                body: transformRequest(plContractKey),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getContractRenewalAvailableScopes: builder.mutation({
            query: (plContractKey) => ({
                url: `/Contract/GetContractRenewalAvailableScopes`,
                method: 'POST',
                body: transformRequest(plContractKey),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteContractRenewalScope: builder.mutation({
            query: ({ plContractKey, plScopeKey }) => ({
                url: `/Contract/RemoveContractRenewalScope?plContractKey=${plContractKey}&plScopeKey=${plScopeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addContractRenewalScope: builder.mutation({
            query: (data) => ({
                url: `Contract/AddContractRenewalScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateRenewalScope: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateRenewalScope`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getContractAgreementTemplate: builder.mutation({
            query: (pbIncludeBlank) => ({
                url: `Contract/GetContractAgreementTemplate`,
                method: 'POST',
                body: transformRequest(pbIncludeBlank),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractAmendmentScopes: builder.mutation({
            query: (data) => ({
                url: `Contract/GetContractAmendmentScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractAmendmentScopeCost: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractAmendmentScopeCost`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractAmendmentScopeChangeDate: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractAmendmentScopeChangeDate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractAmendmentsAvailableScopesList: builder.mutation({
            query: (data) => ({
                url: `Contract/GetContractAmendmentsAvailableScopesList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        insertAmendmentScopes: builder.mutation({
            query: (data) => ({
                url: `Contract/InsertAmendmentScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getContractAffiliatesList: builder.mutation({
            query: (data) => ({
                url: `Contract/GetContractAffiliatesList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addContractAffiliate: builder.mutation({
            query: (data) => ({
                url: `Contract/AddContractAffiliate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateContractAffiliate: builder.mutation({
            query: (data) => ({
                url: `Contract/UpdateContractAffiliate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteContractAffiliate: builder.mutation({
            query: (plAffiliateKey) => ({
                url: `/Contract/DeleteContractAffiliate?plAffiliateKey=${plAffiliateKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        contractAffiliateInvoiceExists: builder.query({
            query: (plAffiliateKey) => ({
                url: `Contract/ContractAffiliateInvoiceExists?plAffiliateKey=${plAffiliateKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        contractDepartmentInvoiceScheduleGet: builder.mutation({
            query: (data) => ({
                url: `Contract/ContractDepartmentInvoiceScheduleGet`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        extractCovered: builder.mutation({
            query: (data) => ({
                url: `/Contract/ExtractCovered`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getClientByContractId: builder.mutation({
            query: (plContractKey) => ({
                url: `Contract/GetClientByContractId?plContractKey=${plContractKey}`,
                method: 'POST',
                body: transformRequest(plContractKey),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addContractScopes: builder.mutation({
            query: (data) => ({
                url: `/Contract/AddContractScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        exportContractScopes: builder.mutation({
            query: (data) => ({
                url: `/Contract/ExportContractScopes`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        invoiceExistsForDepartment: builder.query({
            query: (plContractDepartmentKey) => ({
                url: `/Contract/InvoiceExistsForDepartment?plContractDepartmentKey=${plContractDepartmentKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getcontractDepartmentInvoiceSchedule: builder.query({
            query: ({ plContractKey, plDepartmentKey }) => ({
                url: `/Departments/GetcontractDepartmentInvoiceSchedule?plContractKey=${plContractKey}&plDepartmentKey=${plDepartmentKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        contractDepartmentRemove: builder.mutation({
            query: (plContractDepartmentKey) => ({
                url: `/Contract/ContractDepartmentRemove?plContractDepartmentKey=${plContractDepartmentKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        exportContractCost: builder.mutation({
            query: (data) => ({
                url: `/Contract/ExportContractCost`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        importContractScopes: builder.mutation({
            query: (data) => ({
                url: `/Contract/ImportContractScopes`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCostFromScopesForAllDepartments: builder.mutation({
            query: (plContractKey) => ({
                url: `Contract/UpdateCostFromScopesForAllDepartments?plContractKey=${plContractKey}`,
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        importModelContractScopes: builder.mutation({
            query: (data) => ({
                url: `/Contract/ImportModelContractScopes`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        importCovered: builder.mutation({
            query: (data) => ({
                url: `/Contract/ImportCovered`,
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        insertNewScopesWithCheckSerialNumber: builder.mutation({
            query: (data) => ({
                url: `/Contract/InsertNewScopesWithCheckSerialNumber`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        exportContractCoveredScopesReport: builder.mutation({
            query: (data) => ({
                url: `Contract/ExportContractCoveredScopesReport`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportContractMonthlyRevenueReport: builder.mutation({
            query: ({ pdtMonth }) => ({
                url: `Contract/ExportContractMonthlyRevenueReport?pdtMonth=${pdtMonth}`,
                method: 'POST',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllContractClient: builder.query({
            query: (pbIncludeInactive) => ({
                url: `Contract/GetAllContractClient?pdtMonth=${pbIncludeInactive}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportContractEfficiencyReport: builder.mutation({
            query: (data) => ({
                url: `Contract/ExportContractEfficiencyReport`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        checkScopeSerialNumberExists: builder.query({
            query: (psSerialNumber) => ({
                url: `/Contract/CheckScopeSerialNumberExists?psSerialNumber=${psSerialNumber}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllInvoiceDepartments: builder.query({
            query: ({ plContractKey, pbIncludeBlank, pbBillableOnly }) => ({
                url: `/Contract/GetAllInvoiceDepartments?plContractKey=${plContractKey}&pbIncludeBlank=${pbIncludeBlank}&pbBillableOnly=${pbBillableOnly}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllContractInvoices: builder.mutation({
            query: (data) => ({
                url: `Contract/GetAllContractInvoice`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
});

export const {
    useLazyGetAllContractTypeQuery,
    useAddUpdateContractTypeMutation,
    useDeleteContractTypesMutation,
    useContractScopesAvailableMutation,
    useGetAllContractScopesMutation,
    useLazyGetContractByIdQuery,
    useLazyGetAllContractInstallmentTypesQuery,
    useAddContractMutation,
    useExportContractsListMutation,
    useAddContractScopesMutation,
    useUpdateContractMutation,
    useGetAllsalesTaxMutation,
    useLazyGetAllContractServicePlanTermsQuery,
    useLazyGetAllContractCoverageCountsQuery,
    useLazyGetInstrumentTypesForContractQuery,
    useDeleteContractCoverageCountMutation,
    useAddUpdateContractCoverageCountMutation,
    useContractDepartmentUpdateCostFromScopesMutation,
    useDeleteContractDeferralPeriodMutation,
    useEditContractDepartmentsMutation,
    useUpdateContractNameMutation,
    useLazyGetContractDepartmentsAvailableQuery,
    useLazyGetContractDepartmentsQuery,
    useAddContractDepartmentsMutation,
    useUpdateSharedRiskDateMutation,
    useGetAllSalesrepsMutation,
    useGetAllContractsListMutation,
    useAddCommissionRateMutation,
    useGetAllCommissionRateMutation,
    useDeleteCommissionRateMutation,
    useUpdateCommissionRateMutation,
    useLazyGetAllContractDeferralPeriodsQuery,
    useAddContractDeferralPeriodMutation,
    useUpdateContractDeferralPeriodMutation,
    useLazyGetAmendmentsListQuery,
    useDeleteContractAmendmentsMutation,
    useAddContractAmendmentTypeMutation,
    useUpdateContractAmendmentStatusMutation,
    useLazyGetContractRepairsListQuery,
    useGetContractConsumptionDetailMutation,
    useGetContractExpenseDetailsMutation,
    useExportContractRepairsListMutation,
    useUpdateContractScopeMutation,
    useDeleteContractScopeMutation,
    useDeleteContractAmendmentScopeMutation,
    useGetContractAmendmentScopesMutation,
    useUpdateContractAmendmentScopeCostMutation,
    useUpdateContractAmendmentScopeChangeDateMutation,
    useGetContractAmendmentsAvailableScopesListMutation,
    useInsertAmendmentScopesMutation,
    useGetContractAffiliatesListMutation,
    useAddContractAffiliateMutation,
    useUpdateContractAffiliateMutation,
    useGetContractRenewalScopesMutation,
    useGetContractRenewalAvailableScopesMutation,
    useDeleteContractRenewalScopeMutation,
    useAddContractRenewalScopeMutation,
    useGetContractAgreementTemplateMutation,
    useUpdateRenewalScopeMutation,
    useExtractCoveredMutation,
    useGetClientByContractIdMutation,
    useDeleteContractAffiliateMutation,
    useLazyContractAffiliateInvoiceExistsQuery,
    useContractDepartmentInvoiceScheduleGetMutation,
    useExportContractScopesMutation,
    useLazyInvoiceExistsForDepartmentQuery,
    useContractDepartmentRemoveMutation,
    useLazyGetcontractDepartmentInvoiceScheduleQuery,
    useExportContractCostMutation,
    useImportContractScopesMutation,
    useImportModelContractScopesMutation,
    useImportCoveredMutation,
    useUpdateCostFromScopesForAllDepartmentsMutation,
    useInsertNewScopesWithCheckSerialNumberMutation,
    useExportContractCoveredScopesReportMutation,
    useExportContractMonthlyRevenueReportMutation,
    useLazyGetAllContractClientQuery,
    useExportContractEfficiencyReportMutation,
    useLazyCheckScopeSerialNumberExistsQuery,
    useLazyGetAllInvoiceDepartmentsQuery,
    useGetAllContractInvoicesMutation,
} = contractAPI;

export default contractAPI;